import * as React from 'react';



export default class Logs extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
     

<svg className="ccActive" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <defs>
        <path id="a" d="M13.429.573L.616 13.303a1.497 1.497 0 0 0 0 2.126l12.813 12.729a1.52 1.52 0 0 0 2.14 0l3.215-3.195-2.88-2.86-1.405 1.396-9.194-9.133 9.194-9.134 1.333 1.325 2.88-2.861L15.568.573a1.511 1.511 0 0 0-1.07-.44c-.387 0-.773.146-1.07.44z"/>
        <path id="c" d="M5.298 5.143L2.884 2.79.092 5.511l4.17 4.063a1.496 1.496 0 0 0 2.076 0l1.756-1.71-.003-.001 5.138-5.004L10.436.14 5.298 5.143z"/>
        <path id="e" d="M13.455.573L.642 13.303a1.496 1.496 0 0 0 0 2.126l12.813 12.729a1.52 1.52 0 0 0 2.14 0l3.215-3.195-2.88-2.86-1.405 1.396-9.194-9.133 9.194-9.134 1.333 1.325 2.88-2.861L15.595.573a1.511 1.511 0 0 0-1.07-.44c-.387 0-.774.146-1.07.44z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g transform="translate(3.029 5.172)">
            <mask id="b" fill="#fff">
                <use xlinkHref="#a"/>
            </mask>
            <path fill="#5A65AE" d="M-5.85 34.62h30.655V-5.89H-5.849z" mask="url(#b)"/>
        </g>
        <g transform="translate(25.116 12.94)">
            <mask id="d" fill="#fff">
                <use xlinkHref="#c"/>
            </mask>
            <path fill="#6AC6B9" d="M-5.93 16.014h25.18V-5.882H-5.93z" mask="url(#d)"/>
        </g>
        <g transform="translate(13.951 5.172)">
            <mask id="f" fill="#fff">
                <use xlinkHref="#e"/>
            </mask>
            <path fill="#54B6E7" d="M-5.823 34.62h30.655V-5.89H-5.823z" mask="url(#f)"/>
        </g>
    </g>
</svg>


    )
  }
}
